import { apiSlice } from "./apiSlice";

export const invoiceSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all Invoice list
        getInvoiceList: builder.query({
            query: (params) => ({
                url: `InvoiceApproval`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllInvoice"],
        }),

        // Export all data (without pagination) in Excel File
        getExportInvoiceList: builder.query({
            query: (params) => ({
                url: `InvoiceApproval`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        // Create new Invoice
        createInvoice: builder.mutation({
            query: (body) => ({
                url: `InvoiceApproval`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllInvoice"],
        }),

        // Update Invoice
        updateInvoice: builder.mutation({
            query: (body) => ({
                url: `InvoiceApproval`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ['AllInvoice']
        }),

        // Get all Invoice Comment list
        getInvoiceCommentList: builder.query({
            query: ({ ProjectId, invoiceId }) => ({
                url: `InvoiceApproval/${ProjectId}/${invoiceId}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllInvoiceComment"],
        }),

        // Create new Invoice Comment
        createInvoiceComment: builder.mutation({
            query: (body) => ({
                url: `InvoiceApproval/add-invoicecomment`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllInvoiceComment"],
        }),

    })
})

export const { useLazyGetInvoiceListQuery, useCreateInvoiceMutation, useUpdateInvoiceMutation, useGetInvoiceCommentListQuery,
    useCreateInvoiceCommentMutation, useLazyGetExportInvoiceListQuery
} = invoiceSlice;
